import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page14() {
  useEffect(() => {
    document.title = "Маяк — Страница 13"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page12" />
        <ForwardLink href="/page14" />
      </div>

      <p style={{ textAlign: "right" }}>13.</p>
      <p>МОЛОДОЙ смотрит вверх. Вода попадает ему в глаз.</p>
      <p>СТАРИК ковыляет к своей кровати, его штаны спущены до щиколоток.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Займись этим после цистерны.<br/>
        И заправь лампу маслом.
      </p>
      <p>Он плюхается на обвисший матрас. Мгновенно засыпает.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ТРОПИНКА – ДЕНЬ</p>
      <p>МОЛОДОЙ тащит тяжелый МЕШОК С МЕЛОМ вверх по склону острова.</p>
      <p>Это тяжелая работа.</p>
      <p>Ветер адски дует.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ЦИСТЕРНА – ДЕНЬ</p>
      <p>
        МОЛОДОЙ, с сигаретой во рту, открывает люк кирпичного<br/>
        резервуара: оттуда исходит запах гнили.<br/>
        МОЛОДОЙ отшатывается на несколько дюймов.
      </p>
      <p>
        Он бросает сигарету и закрывает рот и нос<br/>
        платком с шеи.
      </p>
      <p>
        Он смотрит внутрь: там полно плесени и пены.<br/>
        <i>Это то, что он пил.</i>
      </p>
      <p>Он засыпает мел. Мел медленно тонет.</p>
      <p>
        МОЛОДОЙ опускает палку для перемешивания и мешает воду.<br/>
        Она выглядит красиво.
      </p>
      <br/>
      <p>СНАРУЖИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КРЫША – ДЕНЬ</p>
      <p>МОЛОДОЙ скребет старую кедровую черепицу.</p>
      <p>Скребет. Скребет. Скребет.</p>
      <p>
        Он пытается удержать равновесие на шаткой лестнице. Ветер<br/>
        сильно дует, почти сбивая его. Монотонная работа. Он<br/>
        относится к ней ответственно, но с затаенным гневом.
      </p>
      <p>
        Поднимает глаза на маяк: занавески в фонарном отделении<br/>
        задернуты.
      </p>
      <p style={{ textAlign: "right" }}>13.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page12" />
        <ForwardLink href="/page14" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1707873362/the-lighthouse-script/ndtijqwst09qnsopi5mc.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page14;
